import $ from 'jquery';
import 'bootstrap';

import { READER_FILE_DOWNLOAD_API } from '../constants';

export const init = () => {
  const elGenerateBtns = $('a[data-id="file-generate-btn"]');
  $.each(elGenerateBtns, (i, v) => {
    const elem = $(v);
    elem.on('click', (e)=>{
      e.preventDefault();
      e.stopPropagation();
      elem.addClass('d-none');
      elem.parent().next().removeClass('d-none');
      $.get(`${READER_FILE_DOWNLOAD_API}${elem.attr('data-course-id')}/${elem.attr('data-book-id')}/${elem.attr('data-file-id')}`, (res)=>{
        console.log(res)
        elem.parent().next().addClass('d-none');
        elem.parent().next().next().removeClass('d-none').find('a').attr('href', JSON.parse(res).data)
      })
    })
  })
};
